// Copyright (c) 2018 Cigent Technology Inc.

import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-enter-fde-request-dialog',
    templateUrl: './enter-fde-request-dialog.component.html',
    styleUrl: './enter-fde-request-dialog.component.scss',
    standalone: false
})
export class EnterFdeRequestDialogComponent {
    @ViewChild('requestCodeText') requestCodeText: ElementRef;
    form: UntypedFormGroup;

    constructor(private readonly formBuilder: UntypedFormBuilder,
                private readonly dialogRef: MatDialogRef<EnterFdeRequestDialogComponent>) {
        this.form = this.formBuilder.group({
            requestCode: ['', Validators.required]
        });
    }

    onUploadClick(event) {
        const fileInput = event.target;
        const file = fileInput.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            this.form.controls['requestCode'].setValue(reader.result);
        };
        reader.readAsText(file)

        // Reset the file input value to allow re-selection of the same file
        fileInput.value = '';
    }

    clearText(input, event) {
        this.form.controls['requestCode'].setValue('');
        input.value = "";
        input.blur();
        event.stopPropagation();
    }

    onCancelClick() {
        this.dialogRef.close();
    }

    onSaveClick() {
        this.dialogRef.close(this.form.value.requestCode);
    }

}
